import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import ViewContent from "../../../../containers/manage/CreateShotClass/ViewContent/ViewContent";
import { useFetchData } from "../../../../hooks/useFetchData";
import {
  deleteCertificateActionHandler,
  getManageCertificatesActionHandler,
} from "../../../../store/actions/actionHandlers/adminActionHandler/certificateManagementActionHandler";
import { certificateManagement } from "../../../../utils/mainTabs/admin/certificateManagement/certificateManagement";
import DataTable from "../../../Common/DataTable/DataTable";
import Modal from "../../../Common/Modal/Modal";
import AddIcon from "../../../Common/SvgIcons/AddIcon";
import DownloadIconSmall from "../../../Common/SvgIcons/CommonIcons/DownloadIconSmall";
import Tooltip from "../../../Common/ToolTip/Tooltip";
import ManageCertificateModal from "../ManageCertificateModal/ManageCertificateModal";
import classes from "./CertificateManagementTable.module.scss";
import { FormattedMessage } from "react-intl";

const CertificateManagementTable = () => {
  const pageSize = 8;
  const dispatch = useDispatch();
  const [isManageCertificateModal, setIsManageCertificateModal] = useState(0);
  const [isDeleteCertificateModal, setIsDeleteCertificateModal] = useState(0);
  const [isViewCertificateModal, setIsViewCertificateModal] = useState(0);
  const [certificateData, setCertificateData] = useState(null);

  const { columns, downloadSampleCertificateLink } = certificateManagement;

  const adminStateReducer = useSelector((state) => state.adminReducer);
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  const { certificateManagementReducer } = adminStateReducer;
  const { deleteCertificateLoader } = certificateManagementReducer;

  const {
    data,
    setData,
    updatedData,
    setUpdatedData,
    totalRows,
    loading,
    searchQuery,
    handleCurrentPage,
    handleSearchQuery,
  } = useFetchData(getManageCertificatesActionHandler, pageSize);

  const handleManageCertificateModal = (val) => {
    if (val !== 0 && val !== 1) {
      const certificateData = data.find(
        (dataVal) => dataVal.CertificateID === val
      );
      setCertificateData(certificateData);
    } else {
      setCertificateData(null);
    }
    setIsManageCertificateModal(val);
  };

  const handleViewCertificateModal = (val) => {
    if (val === 0) {
      setCertificateData(null);
    } else {
      const pdfData = data.find((dataVal) => dataVal.CertificateID === val);
      setCertificateData(pdfData);
    }
    setIsViewCertificateModal(val);
  };

  const handleDeleteCertificateModal = (val) => {
    setIsDeleteCertificateModal(val);
  };
  const handleDeleteCertificate = () => {
    dispatch(deleteCertificateActionHandler(isDeleteCertificateModal)).then(
      (response) => {
        if (response?.status >= 200) {
          const updatedArr = data.filter(
            (dataVal) => dataVal.CertificateID !== isDeleteCertificateModal
          );
          setData(updatedArr);
          setUpdatedData(updatedArr);
        }
        setIsDeleteCertificateModal(0);
      }
    );
  };

  return (
    <div className={classes.certificateManagementTable}>
      <div className={classes.certificateManagementTable__header}>
        <div
          className={
            classes.certificateManagementTable__header__certificateCount
          }
        >
          <FormattedMessage id="Report_Total" /> {totalRows || 0} <FormattedMessage id="CERTIFICATES" />
        </div>
        <div
          className={
            classes.certificateManagementTable__header__certificateAction
          }
        >
          <Tooltip
            content={"Click here to download sample certificate"}
            direction={"bottom"}
          >
            <a
              href={downloadSampleCertificateLink}
              target="_blank"
              rel="noreferrer"
              className={
                classes.certificateManagementTable__header__certificateAction__download
              }
            >
              <DownloadIconSmall fill={colors.theme} />
              Download Sample Certificate
            </a>
          </Tooltip>
          <div
            className={
              classes.certificateManagementTable__header__certificateAction__add
            }
            onClick={() => handleManageCertificateModal(1)}
          >
            <AddIcon fill={colors.theme} />
            Upload New Certificate
          </div>
        </div>
      </div>
      <DataTable
        columns={columns(
          handleManageCertificateModal,
          handleDeleteCertificateModal,
          handleViewCertificateModal
        )}
        defaultData={data}
        setDefaultData={setData}
        data={updatedData}
        setData={setUpdatedData}
        totalRows={totalRows}
        loading={loading}
        uniqueFieldName={"CertificateID"}
        fetchMoreData={handleCurrentPage}
        searchable
        searchQuery={searchQuery}
        setSearchQuery={handleSearchQuery}
      />
      <ManageCertificateModal
        isManageCertificateModal={isManageCertificateModal}
        handleManageCertificateModal={handleManageCertificateModal}
        certificateData={certificateData}
        handleSearchQuery={handleSearchQuery}
      />
      <Modal
        isOpen={isDeleteCertificateModal}
        heading={<FormattedMessage id="SHOTCLASS_POPUP_HEADER" />}
        toggle={() => handleDeleteCertificateModal(0)}
        buttonLabel1={<FormattedMessage id="YES_TEXT" />}
        buttonLabel2={<FormattedMessage id="CANCEL_TEXT" />}
        handleSubmit={handleDeleteCertificate}
        width="46.2"
        height="26.9"
        loading={deleteCertificateLoader}
      >
        <div className={classes.certificateManagementTable__deleteModal}>
          <div
            className={classes.certificateManagementTable__deleteModal__text}
          >
            <FormattedMessage id="Cert_want_to_delete" />
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={isViewCertificateModal && certificateData}
        heading={<FormattedMessage id="VIEW_SHOTCLASS_HOME" />}
        toggle={() => handleViewCertificateModal(0)}
        width="60"
        height="44"
        // loading={deleteCertificateModal}
      >
        <ViewContent
          shotclassData={{
            Mediatype: 7,
            VideoUrl: certificateData?.CertificateUrl,
            Name: certificateData?.Name,
          }}
        />
      </Modal>
    </div>
  );
};

export default CertificateManagementTable;
